import {
  ChevronsLeft,
  ChevronLeft,
  ChevronRight,
  ChevronsRight,
} from "lucide-react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    const sideCount = 3;

    // Always show first 3 pages
    for (let i = 1; i <= Math.min(sideCount, totalPages); i++) {
      pages.push(i);
    }

    if (currentPage > sideCount + 2) {
      pages.push("...");
    }

    const start = Math.max(currentPage - 1, sideCount + 1);
    const end = Math.min(currentPage + 1, totalPages - sideCount);

    for (let i = start; i <= end; i++) {
      if (i > sideCount && i < totalPages - sideCount + 1) {
        pages.push(i);
      }
    }

    if (currentPage < totalPages - sideCount - 1) {
      pages.push("...");
    }

    for (
      let i = Math.max(totalPages - sideCount + 1, sideCount + 1);
      i <= totalPages;
      i++
    ) {
      if (i > sideCount) {
        pages.push(i);
      }
    }

    return pages;
  };

  const isActive = (page) =>
    `px-3 py-1 rounded-md border border-[#FFDEDE] text-[12px] ${
      page === currentPage
        ? "bg-[#FFDEDE] text-[#000000] border border-gray-300"
        : "text-[#5C5C5C] hover:bg-gray-200 border-gray-300"
    }`;

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center gap-[10px] text-sm">
      {/* Double Left */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(1)}
        className="p-2 pl-0 hover:bg-gray-200 rounded disabled:opacity-50"
      >
        <ChevronsLeft size={18} color="#5C5C5C" />
      </button>

      {/* Single Left */}
      <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="p-2 pl-0 hover:bg-gray-200 rounded disabled:opacity-50"
      >
        <ChevronLeft size={18} color="#5C5C5C" />
      </button>

      {/* Page numbers */}
      {pageNumbers.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={index}
            onClick={() => onPageChange(item)}
            className={isActive(item)}
          >
            {item}
          </button>
        ) : (
          <span key={index} className="px-[10px">
            ...
          </span>
        ),
      )}

      {/* Single Right */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className="p-2 pr-0 hover:bg-gray-200 rounded disabled:opacity-50"
      >
        <ChevronRight size={18} color="#5C5C5C" />
      </button>

      {/* Double Right */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(totalPages)}
        className="p-2 pr-0 hover:bg-gray-200 rounded disabled:opacity-50"
      >
        <ChevronsRight size={18} color="#5C5C5C" />
      </button>
    </div>
  );
};

export default Pagination;
